import { Component, Output, EventEmitter, Input, ViewChild, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalDirective } from "../../directives/modal.directive";

@Component({
    selector: "commentsmodal",
    templateUrl: "./commentsmodal.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CommentsModalComponent implements OnInit {
    @Output() onCommentsUpdated = new EventEmitter();
    @Input() comments: string = "";
    @Input() title: string = "";
    @Input() required: boolean = false;
    @Input() headerText: string = "";
    @Input() submitButtonText: string = "";
    commentsForm: FormGroup;
    loaded: boolean = false;
    config: any = {};
    @ViewChild("commentsModal") public commentsModal: ModalDirective;

    /**
     * Initializes the modal and sets the validation for the form
     */
    ngOnInit(): void {
        this.commentsForm = new FormGroup({
            commentsContent: new FormControl(this.comments)
        });
    }

    onOpenModal(): void {
        setTimeout(() => {
            this.loaded = true;
            if (this.required) {
                this.commentsForm.controls["commentsContent"].setValidators([Validators.required]);
            } else {
                this.commentsForm.controls["commentsContent"].setValidators(null);
            }
            (<FormControl>this.commentsForm.controls["commentsContent"]).setValue(this.comments, { onlySelf: true });
            this.commentsForm.controls["commentsContent"].updateValueAndValidity();

        }, 200);
    }

    /**
     * Emits the change to the caller and closes the modal
     */
    onCommentsSave(): void {
        this.onCommentsUpdated.emit({
            comments: this.commentsForm.controls["commentsContent"].value
        } as any);

        this.commentsModal.hide();
    }

    openModal(): void {
        this.commentsForm.reset();
        this.onOpenModal();
        this.commentsModal.show();
    }

    closeModal(): void {
        this.commentsModal.hide();
    }
}
